"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullPlan = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _PlanSelection = require("../../molecules/PlanSelection");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GeneralButton = require("../../atoms/GeneralButton");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var FullPlan = function FullPlan(_ref) {
  var title = _ref.title,
      textGeneral = _ref.textGeneral,
      containerData = _ref.containerData;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      buttonActive = _useState2[0],
      setbuttonActive = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "title",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
        headerType: "product-name-header",
        text: title,
        color: _variables.GlobalColors.original_purpura
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "general-text",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: textGeneral
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlanSelection.PlanSelection, {
      planSelection: containerData,
      setbuttonActive: setbuttonActive
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: buttonActive ? "general-default-button" : "general-transparent-button",
      label: "Continuar"
    })]
  });
};

exports.FullPlan = FullPlan;